
export default 'yy-date-picker-cells'